var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 74.494,
  cy: 74,
  r: 74,
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  width: 71.548,
  height: 103.166,
  x: 39,
  y: 22,
  fill: "currentColor",
  rx: 6
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  width: 71.548,
  height: 103.166,
  x: 39,
  y: 22,
  stroke: "currentColor",
  strokeWidth: 4,
  rx: 6
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 74.775,
  cy: 61.209,
  r: 24.399,
  fill: "currentColor"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 74.775,
  cy: 61.209,
  r: 24.399,
  fill: "currentColor"
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  mask: "url(#set-up-complete_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M65.956 84.519a.567.567 0 01-.566.565.567.567 0 01-.566-.566c0-.31.255-.565.566-.565.311 0 .566.254.566.566z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 75.002,
  cy: 87.001,
  r: 20
}));

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 75.002,
  cy: 55,
  r: 8,
  fill: "currentColor"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  width: 21.558,
  height: 2.874,
  x: 63.994,
  y: 92.013,
  fill: "currentColor",
  rx: 1.437
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  width: 50.302,
  height: 2.874,
  x: 49.623,
  y: 100.636,
  fill: "currentColor",
  rx: 1.437
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  width: 50.302,
  height: 2.874,
  x: 49.623,
  y: 104.948,
  fill: "currentColor",
  rx: 1.437
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  width: 50.302,
  height: 2.874,
  x: 49.623,
  y: 109.259,
  fill: "currentColor",
  rx: 1.437
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  width: 14.606,
  height: 14.606,
  x: 79.811,
  y: 67.811,
  fill: "currentColor",
  rx: 7.303
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  width: 14.606,
  height: 14.606,
  x: 79.811,
  y: 67.811,
  stroke: "currentColor",
  strokeWidth: 1.623,
  rx: 7.303
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 1.623,
  d: "M83.683 75.568l2.154 1.884 4.46-4.899"
});

var SvgSetUpComplete = function SvgSetUpComplete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 149 148",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, /*#__PURE__*/React.createElement("mask", {
    id: "set-up-complete_svg__a",
    style: {
      maskType: "alpha"
    },
    width: 50,
    height: 50,
    x: 50,
    y: 36,
    maskUnits: "userSpaceOnUse"
  }, _ref6), _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSetUpComplete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/set-up-complete.1de0ae00.svg";
export { ForwardRef as ReactComponent };